// Core
import React, { useState, useEffect, useRef } from 'react';
import { 
	Box,
	FormControl,
	Input,
	InputGroup,
	InputLeftElement
} from '@chakra-ui/react';

// Components
import Partners from '../Partners';
import { SearchIcon } from 'components/Icons/Icons';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';

const AffiliatePartners = ({ userData }) => {
	const [search, setSearch] = useState('');
	const debounceRef = useRef(null);
	const [isLoadingPage, setIsLoadingPage] = useState(false); 
	const [partnersIsHidden, setPartnersIsHidden] = useState(false); 

	const handleSearch = (event) => {
	    setIsLoadingPage(true);

	    const value = event.target.value;
	    clearTimeout(debounceRef.current);
	    debounceRef.current = setTimeout(() => {
	      setSearch(value);
	    }, 600);
	};

	return (
	    <Box pt="18px">

			<Breadcrumbs target="Discounts" url="/discounts" current="Discover" />

	        <FormControl id="search" mt="20px" mb="24px">
	          <InputGroup>
	            <InputLeftElement>
	              <SearchIcon fontSize="24px" color="#9FABCB" m="6px 0 0 6px" />
	            </InputLeftElement>
	            <Input
	              p="15px 45px!important"
	              h="48px !important"
	              onChange={handleSearch}
	              placeholder='Search'
	              autoComplete="off"
	            />
	          </InputGroup>
	        </FormControl>

	        <Partners 
	        	userData={userData} 
	        	key={search} 
	        	type="affiliate-partner" 
	        	search={search} 
	        	limit={24} 
	        	isLoadingPage={isLoadingPage}
			    setIsLoadingPage={setIsLoadingPage}
			    setPartnersIsHidden={setPartnersIsHidden}
	        	includeLoadMore={true} />

	        <Box mt="80px" />
	    </Box>
	);
};

export default AffiliatePartners;